export interface PropertySpecificationsDto {
  id: string;
  propertyType: PropertyType | null;
  architectureStyle: ArchitectureStyle | null;
  squareFeet: number | null;
  fullBathrooms: number | null;
  halfBathrooms: number | null;
  bedrooms: number | null;
  yearBuilt: number | null;
  numberOfFloors: number | null;
  apartmentFloor: number | null;
}

export enum PropertyType {
  ROOM = 'Room',
  STUDIO = 'Studio',
  APARTMENT = 'Apartment',
  HOUSE = 'House',
  CONDO = 'Condo',
  TOWNHOUSE = 'Townhouse',
  DUPLEX = 'Duplex',
}

export enum ArchitectureStyle {
  BUNGALOW = 'Bungalow',
  CAPE_COD = 'Cape Cod',
  COLONIAL = 'Colonial',
  CONTEMPORARY = 'Contemporary',
  CRAFTSMAN = 'Craftsman',
  FRENCH = 'French',
  GEORGIAN = 'Georgian',
  LOFT = 'Loft',
  MODERN = 'Modern',
  QUEEN_ANNE_VICTORIAN = 'Queen Anne Victorian',
  RANCH_RAMBLER = 'Ranch/Rambler',
  SANTA_FE_PUEBLO_STYLE = 'Santa Fe/Pueblo Style',
  SPANISH = 'Spanish',
  SPLIT_LEVEL = 'Split-level',
  TUDOR = 'Tudor',
  OTHER = 'Other',
}
